import { Directive, OnInit, OnDestroy, Input, ElementRef, HostListener, HostBinding } from '@angular/core';
import { TooltipService } from './tooltip.service';
import { Tooltip } from './Tooltip';


function isTooltip(tooltip: string | Tooltip): tooltip is Tooltip {
  return !!tooltip && (<Tooltip>tooltip).content !== undefined;
}

@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective implements OnInit, OnDestroy {

  @Input() appTooltip: string | Tooltip | undefined;
  tooltip: Tooltip | undefined;
  hovering = false;
  showDelay = 500;
  initialised = false;
  @Input() solo = false;
  @HostBinding('attr.aria-label') ariaLabel?: string;

  constructor(
    private element: ElementRef, private service: TooltipService) { }

  ngOnInit() {
    if (!this.appTooltip) { return; }


    // if tooltip is supplied as string only, construct a tooltip object
    if (!isTooltip(this.appTooltip)) {
      const content: string = <string>this.appTooltip;
      const wordCount = content.split(' ').length;
      this.tooltip = {
        content,
        placement: 'top',
        showOnHover: true,
        width: wordCount < 3 ? 120 : 180,
        solo: true
      };
    } else {
      this.tooltip = Object.assign({}, this.appTooltip);
    }

    const solo = this.tooltip.solo !== undefined ? this.tooltip.solo : this.solo;
    const id = this.tooltip.id || Math.random();

    this.tooltip = Object.assign(this.tooltip,
      {
        id,
        solo,
        source: this.element,
        visible: false,
        width: this.tooltip.width || 180
      }
    );

    this.service.add(this.tooltip);

    this.ariaLabel = this.removeTags(this.tooltip.content);


  }

  removeTags(content: string | undefined): string {
    if (!content) { return ''; }
    let withoutTags = content.replace(/<[^>]*>/g, ' ');
    withoutTags = withoutTags.replace(/\s+/g, ' ');
    return withoutTags.trim();
  }

  @HostListener('click') onClick() {
    if (this.tooltip && this.tooltip.showOnClick) {
      this.toggle();
    }
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (this.tooltip && this.tooltip.showOnHover) {
      this.hoverShow();
    }

  }
  @HostListener('focus') onFocus() {
    if (this.tooltip && this.tooltip.showOnFocus) {
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip && this.tooltip.showOnHover) {
      this.hide();
    }
  }

  @HostListener('blur') onBlur() {
    if (this.tooltip && this.tooltip.showOnFocus) {
      this.hide();
    }
  }

  hoverShow() {
    if (!this.tooltip || this.tooltip.notSolo) { return; }
    const tooltip = this.tooltip;
    if (this.service.soloTip === tooltip) { return; }
    if (this.service.activeContext) { return; }
    this.hovering = true;
    setTimeout(() => {
      if (this.service.activeContext) { return; }
      if (this.hovering && !(tooltip.isHidden && tooltip.isHidden())) {
        this.service.showTooltip(tooltip);
      }
    }, this.showDelay);
  }

  toggle() {
    if (this.tooltip && this.service.soloTip === this.tooltip) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    if (!this.tooltip || this.tooltip.notSolo) { return; }
    if (this.service.soloTip === this.tooltip) { return; }
    if (this.service.activeContext) { return; }
    this.service.showTooltip(this.tooltip);
  }

  hide() {

    this.hovering = false;
    if (!this.tooltip) { return; }
    this.service.hideTooltip(this.tooltip);
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    if (!this.tooltip) { return; }
    this.service.remove(this.tooltip);
    this.hovering = false;
    if (this.service.soloTip === this.tooltip) {
      this.service.soloTip = undefined;
    }
    this.tooltip = undefined;
  }
}
